import(/* webpackMode: "eager" */ "/var/www/smartclass/frontend/public/src/components/pages/not-found/NotFound.tsx")